/**
 * Author: Qian.qianchen 2018-08-30
 */
angular.module('selectDocumentInternalLinkModule', []).controller('selectDocumentInternalLinkCtrl', [
    '$scope',
    '$modalInstance',
    '$state',
    '$q',
    'trsHttpService',
    'localStorageService',
    'websiteLeftService',
    function($scope, $modalInstance, $state, $q, trsHttpService, localStorageService, websiteLeftService) {
        initStatus();
        initData();
        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 6,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.status = {
                curChannelid: $state.params.wzchannelid,
                isSearch: false,
                treeOptions: {
                    nodeChildren: 'CHILDREN',
                    dirSelectable: true,
                    allowDeselect: false,
                    injectClasses: {
                        ul: 'a1',
                        li: 'a2',
                        liSelected: 'a7',
                        iExpanded: 'a3',
                        iCollapsed: 'a4',
                        iLeaf: 'a5',
                        label: 'a6',
                        labelSelected: '',
                    },
                    isLeaf: function(node) {
                        return node.HASCHILDREN === 'false';
                    },
                },
                fromFragment: true,
                isChooseSite: false,
                searchAll: [
                    {
                        name: '标题',
                        value: '0',
                        placeholder: '请输入标题',
                    },
                    {
                        name: 'ID',
                        value: '1',
                        placeholder: '请输入稿件ID',
                    },
                ],
                searchPosition: {
                    0: 'SiteId',
                    1: 'ChannelId',
                },
                SearchValue: '',
                copyCurrPage: 1,
                isApp: false,
                isAppNews: false,
            };
            $scope.data = {
                dropDown: {
                    searchAllType: $scope.status.searchAll,
                    searchAllSelected: $scope.status.searchAll[0],
                },
                treeData: {},
                siteDesc: '',
                selectedNode: {},
            };
            $scope.selectedItem = {
                item: {},
                text: '',
                code: '',
                isBlank: false,
            };
            /*
              判断使用metaDataId还是recId  
             */
            $scope.status.showMetadaId = true;
        }
        /**
         * [initData description] 获取数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            memorySelectedChannel($state.params.wzchannelid);
            $scope.loadingPromise = getTreeData().then(function() {
                $scope.status.curChannelid = $scope.data.selectedNode.CHANNELID;
                $scope.loadingPromise = requestData();
            });
        }
        /**
         * [getTreeData description]获取左侧树数据
         */
        function getTreeData() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryClassifyBySite',
                SiteId: $state.params.wzsiteid,
                platform: 1, // 目前只有网站渠道待编时编辑器有插入内链
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.siteDesc = data.SITEDESC;
                $scope.data.treeData = data.CHILDREN;
                var memoryChannelid = localStorageService.get('selectDocumentChannelMemory');
                if (memoryChannelid !== null) {
                    firstColumnCheck($scope.data.treeData, memoryChannelid).then(
                        function(data) {
                            $scope.data.selectedNode = data;
                            deffer.resolve(data);
                        },
                        function() {
                            websiteLeftService.positionSelectChannel($scope.data.treeData, memoryChannelid, 1, $scope.expandedTest).then(
                                function(selectedChannel) {
                                    $scope.data.selectedNode = selectedChannel;
                                    deffer.resolve(selectedChannel);
                                },
                                function() {
                                    $scope.data.selectedNode = $scope.data.treeData[0];
                                    deffer.resolve($scope.selectedNode);
                                }
                            );
                        }
                    );
                } else {
                    for (var i = 0; i < $scope.data.treeData.length; i++) {
                        if ($scope.data.treeData[i].CHANNELID === $state.params.wzchannelid) {
                            $scope.data.selectedNode = $scope.data.treeData[i];
                            break;
                        }
                    }
                    deffer.resolve(data);
                }
            });
            return deffer.promise;
        }
        /**
         * [firstColumnCheck description] 一级栏目选中检查
         * @param  {[type]} treeData  [description] 树数据
         * @param  {[type]} channelid [description] 选中的channelid
         * @return {[type]}           [description]
         */
        function firstColumnCheck(treeData, channelid) {
            var deffer = $q.defer();
            var flag = false;
            var selectedChannel;
            for (var i = 0; i < treeData.length; i++) {
                var data = treeData[i];
                if (data.CHANNELID === channelid) {
                    selectedChannel = data;
                    flag = true;
                    break;
                }
            }
            if (flag) {
                deffer.resolve(selectedChannel);
            } else {
                deffer.reject();
            }
            return deffer.promise;
        }
        /**
         * [requestData description]获取列表数据full
         * @param  {[boolean]} requestData   [description] 是否按条件搜索
         */
        function requestData() {
            var deffer = $q.defer();
            setSearchOption();
            var selectOption = siteOrChannel();
            var params = {
                serviceid: 'mlf_metadata',
                methodname: 'queryMetaByChannel',
                IsPicDoc: false,
                PageSize: $scope.page.PAGESIZE,
                CurrPage: $scope.page.CURRPAGE,
                IsCurrentChnl: false,
                SearchDocId: '',
                SearchRecId: $scope.status.SearchRecId,
                SearchTitle: $scope.status.SearchTitle,
            };
            if (selectOption === 'siteid') {
                params.ChannelId = $scope.status.curChannelid;
            } else {
                params.SiteId = $state.params.wzsiteid;
            }
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get")
                .then(function(data) {
                    $scope.data.items = data.DATA;
                    $scope.page = data.PAGER;
                    $scope.status.copyCurrPage = data.PAGER.CURRPAGE;
                    deffer.resolve(data);
                }, function(){
                    deffer.reject();
                });
            return deffer.promise;
        }
        /**
         * [setSearchOption description]设置搜索条件
         */
        function setSearchOption() {
            if ($scope.status.isSearch !== true) {
                delete $scope.status.SearchValue;
                delete $scope.status.SearchRecId;
                delete $scope.status.SearchTitle;
            } else {
                if ($scope.data.dropDown.searchAllSelected.value === '0') {
                    $scope.status.SearchTitle = $scope.status.SearchValue;
                    delete $scope.status.SearchRecId;
                } else {
                    $scope.status.SearchRecId = $scope.status.SearchValue;
                    delete $scope.status.SearchTitle;
                }
            }
        }
        /**
         * [siteOrChannel description] 区分站点搜索和栏目搜索
         * @return {[type]} [description]
         */
        function siteOrChannel() {
            if (!$scope.status.isChooseSite) {
                return 'siteid';
            } else {
                return 'channelid';
            }
        }
        /**
         * [fullTextSearch description]按条件检索
         */
        $scope.fullTextSearch = function() {
            $scope.status.isSearch = true;
            requestData();
        };
        /**
         * [chooseSite description] 选择整个站点
         * @return {[type]} [description]
         */
        $scope.chooseSite = function() {
            if ($scope.status.isApp === true && $scope.status.isAppNews === false) {
                return;
            }
            $scope.status.isChooseSite = true;
            $scope.status.SearchDocId = '';
            $scope.status.SearchRecId = '';
            $scope.status.SearchTitle = '';
            $scope.status.curChannelid = $state.params.wzchannelid;
            requestData();
        };
        /**
         * [memorySelectedChannel description]记忆选择过的栏目，方便下次操作
         * @param  {[type]} channelid [description]
         * @return {[type]}           [description]
         */
        function memorySelectedChannel(channelid) {
            localStorageService.set('selectDocumentChannelMemory', channelid);
        }
        /**
         * [showSelected description] 展示选中栏目节点
         * @param  {[object]} node [description] 栏目节点
         * @return {[type]}      [description]
         */
        $scope.showSelected = function(node) {
            memorySelectedChannel(node.CHANNELID);
            $scope.status.isSearch = false;
            $scope.status.isChooseSite = false;
            $scope.page.CURRPAGE = 1;
            $scope.status.curChannelid = node.CHANNELID;
            $scope.loadingPromise = requestData();
        };
        /**
         * [checkChecked description] 判断稿件是否选中
         * @param  {[object]} item [description] 稿件对象
         * @return {[type]}      [description]
         */
        $scope.checkChecked = function(item) {
            if ($scope.selectedItem.item.METADATAID == item.METADATAID && $scope.selectedItem.item.RECID == item.RECID) {
                return true;
            } else {
                return false;
            }
        };
        /**
         * [selectDoc description] 稿件单选事件
         * @param  {[object]} item [description] 稿件对象
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function(item) {
            if ($scope.checkChecked(item)) {
                $scope.selectedItem = {
                    item: {},
                    text: '',
                    code: '',
                    isBlank: false,
                };
            } else {
                $scope.selectedItem.item = item;
                $scope.selectedItem.text = $scope.selectedItem.item.TITLE;
                textAndCode();
            }
        };
        /**
         * [textAndCode description] 根据选择改变文字
         * @return {[type]} [description]
         */
        function textAndCode() {
            if ($scope.selectedItem.text == undefined || $scope.selectedItem.text == '') return;
            var isBlank = $scope.selectedItem.isBlank ? 'target="_blank"' : '';
            var textString = '<a href="' + $scope.selectedItem.item.DOCPUBURL + '" ' + isBlank + '>' + $scope.selectedItem.text + '</a>';
            $scope.selectedItem.code = textString;
        }

        $scope.$watch('selectedItem.text', function(newValue, oldVAlue) {
            textAndCode();
        });
        $scope.showToggle = function(node) {
            if (angular.isDefined(node.CHILDREN) && node.CHILDREN.length === 0 && node.HASCHILDREN === 'true') {
                var childrenTreeParam = {
                    serviceid: 'mlf_mediasite',
                    methodname: 'queryClassifyByChnl',
                    ChannelId: node.CHANNELID,
                    platform: 1, // 目前只有网站渠道待编时编辑器有插入内链
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), childrenTreeParam, 'get').then(function(data) {
                    node.CHILDREN = data.CHILDREN;
                });
            }
        };
        /**
         * [openPuburl description]打开链接地址
         */
        $scope.openPuburl = function(item) {
            window.open(item.DOCPUBURL);
        };
        /**
         * [description] 分页跳转
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            $scope.page.CURRPAGE = angular.copy($scope.status.copyCurrPage);
            $scope.loadingPromise = requestData();
        };
        /**
         * [pageChanged description] 翻页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.loadingPromise = requestData();
        };
        /**
         * [cancel description] 弹框关闭
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        /**
         * [confirm description]确认提交
         */
        $scope.confirm = function() {
            $modalInstance.close($scope.selectedItem.code);
        };
    },
]);
